let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9dhzF"), load("3r4xb"), load("aoJPa")]).then(() => parcelRequire('kaQDe'));